import React from 'react';
import PropTypes from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { initIndexDB } from '@thd-olt-global/thd-storage-utils';
import { AssistantProvider } from './AssistantProvider';
import { DrawerProvider } from './DrawerProvider';
import { MagicApronAssistant } from './MagicApronAssistant';

const indexDBConfig = {
  version: 2,
  stores: {
    sessions: {
      storeConfig: { keyPath: 'sessionId' },
      indexes: [{ name: 'sessionId', unique: true }],
    },
    messages: {
      storeConfig: { keyPath: 'id', autoIncrement: true },
      indexes: [{ name: 'id', unique: true }],
    }
  }
};

initIndexDB('assistantBotDB', indexDBConfig).catch(() => {});

/**
 * The AssistantWrapper component is responsible for providing the
 * context and configuration for the Assistant.
 * @param {Object} props - The component props.
 * @param {boolean} props.withPersistence - Flag to enable persistence.
 * @returns {JSX.Element} The rendered component.
 */

export const AssistantWrapper = ({ withPersistence }) => {

  return (
    <AssistantProvider withPersistence={withPersistence}>
      <DrawerProvider>
        <MagicApronAssistant />
      </DrawerProvider>
    </AssistantProvider>
  );
};

AssistantWrapper.propTypes = {
  withPersistence: PropTypes.bool,
};

AssistantWrapper.defaultProps = {
  withPersistence: true,
};

AssistantWrapper.dataModel = extend(MagicApronAssistant);
